import { connect } from 'react-redux';
import { moveNext, movePrev } from '../redux/actionCreators';
import { getDuperbrowseNavigation, getIsDuperbrowseActive, getIsKeyboardDuperbrowseAllowed, } from '../redux/selectors';
var mapStateToProps = function (state) { return ({
    navigation: getDuperbrowseNavigation(state),
    isDuperbrowseActive: getIsDuperbrowseActive(state),
    enableKeyboardNavigation: getIsKeyboardDuperbrowseAllowed(state),
}); };
var mapDispatchToProps = {
    moveNext: moveNext,
    movePrev: movePrev,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=DuperbrowsePaddles.container.js.map